import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRevenueCodeLookupMulticompany extends Layout {
    sourceRevenueCodeLookup: DataSource;
    tableRevenueCodeLookup: Table;
}
